import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { MatDialogRef, MatDialog } from '@angular/material';
import 'hammerjs';

@Component({
  selector: 'app-privacy-dialog',
  templateUrl: 'privacy-dialog.component.html',
  styleUrls: ['privacy-dialog.component.scss']
})

export class PrivacyDialogComponent implements OnInit, OnDestroy {

  constructor(// public dialogRef: MatDialogRef<PrivacyDialogComponent>,
              // public dialog: MatDialog
              ) {

  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

}
